import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, createSlots as _createSlots, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78c20619"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<p class=\"text-white\" data-v-78c20619>El tiempo de sincronización es mayor a 2 minutos</p><svg height=\"100\" width=\"100\" data-v-78c20619><circle stroke-linecap=\"round\" transform-origin=\"50 50\" cx=\"50\" cy=\"50\" r=\"40\" stroke-width=\"5\" stroke=\"white\" fill=\"none\" stroke-dasharray=\"125.66\" data-v-78c20619><animateTransform attributeName=\"transform\" type=\"rotate\" dur=\"1s\" to=\"360\" repeatCount=\"indefinite\" data-v-78c20619></animateTransform></circle><circle stroke-linecap=\"round\" transform-origin=\"50 50\" cx=\"50\" cy=\"50\" r=\"30\" stroke-width=\"5\" stroke=\"white\" fill=\"none\" stroke-dasharray=\"94.245\" data-v-78c20619><animateTransform attributeName=\"transform\" type=\"rotate\" dur=\".8s\" to=\"360\" repeatCount=\"indefinite\" data-v-78c20619></animateTransform></circle></svg>", 2)
const _hoisted_4 = [
  _hoisted_2
]
const _hoisted_5 = { class: "fs-1 fw-bold" }
const _hoisted_6 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "card-header border-0 pt-0 px-0" }
const _hoisted_9 = { class: "card-title" }
const _hoisted_10 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-sm-3 col-md-3 col-lg-3 col-xs-12 mt-2 pe-0" }
const _hoisted_13 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_14 = { class: "col-sm-3 col-md-3 col-lg-3 col-xs-12 mt-2 pe-0" }
const _hoisted_15 = { class: "col-sm-3 col-md-3 col-lg-3 col-xs-12 mt-2 pe-0" }
const _hoisted_16 = {
  key: 0,
  class: "col-sm-3 col-md-3 col-lg-3 col-xs-12 mt-2 pe-0"
}
const _hoisted_17 = { class: "card-toolbar" }
const _hoisted_18 = {
  class: "d-flex justify-content-end",
  "data-kt-subscription-table-toolbar": "base"
}
const _hoisted_19 = { class: "svg-icon svg-icon-2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Descargar"),
  /*#__PURE__*/_createElementVNode("span", null, " listado")
], -1))
const _hoisted_21 = { class: "svg-icon svg-icon-2" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Sincronizar"),
  /*#__PURE__*/_createElementVNode("span", null, " vehículos")
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Agregar"),
  /*#__PURE__*/_createElementVNode("span", null, " Vehículo")
], -1))
const _hoisted_24 = {
  key: 0,
  class: "d-flex align-items-center position-relative my-1 alert alert-dismissible bg-light-primary row col-md-3 col-sm-3 col-lg-3 col-xs-12"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-5 fw-bold" }, "No se encontraron registros", -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "card-body pt-0 px-0" }
const _hoisted_28 = {
  key: 0,
  style: {"float":"left"}
}
const _hoisted_29 = {
  key: 1,
  style: {"float":"left","width":"100%"}
}
const _hoisted_30 = {
  key: 2,
  style: {"float":"left","margin-right":"20px"}
}
const _hoisted_31 = { style: {"float":"right","margin-right":"20px"} }
const _hoisted_32 = {
  src: "media/icons/iconsax/blue_dot.svg",
  style: {"height":"13px","margin-right":"7px"}
}
const _hoisted_33 = {
  src: "media/icons/iconsax/blue_dot_light.svg",
  style: {"height":"13px","margin-right":"7px"}
}
const _hoisted_34 = {
  src: "media/icons/iconsax/red_dot.svg",
  style: {"height":"13px","margin-right":"7px"}
}
const _hoisted_35 = {
  src: "media/icons/iconsax/green_dot.svg",
  style: {"height":"13px","margin-right":"7px"}
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 0,
  class: "row"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Sin resultados")
], -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = {
  key: 1,
  class: "row align-items-center py-3 px-3 top-less-6 m-0 border border-top-0 border-gray-600 rounded-bottom bg-gray footer-position-table"
}
const _hoisted_41 = { class: "col-sm-12 col-md-6 mb-3 mb-md-0 d-flex flex-row align-items-center fs-base" }
const _hoisted_42 = { class: "me-2" }
const _hoisted_43 = { class: "col-sm-12 col-md-6 text-end" }
const _hoisted_44 = {
  id: "kt_referre_dusers_tab_content_pagination",
  class: "tab-content"
}
const _hoisted_45 = { class: "pagination justify-content-end" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = {
  key: 0,
  class: "page-link"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Field = _resolveComponent("Field")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_ModalDeleteVehicle = _resolveComponent("ModalDeleteVehicle")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.showLoader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.path == '/vehicles' ? 'w-full negative-top' : 'w-full'])
    }, [
      _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.path == "/vehicles/" + _ctx.idAgency
            ? "Vehículos"
            : "Vehículos registrados"), 1),
      (_ctx.path == '/vehicles/' + _ctx.idAgency)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.total) + " " + _toDisplayString(_ctx.total == 1 ? " Registro" : " Registros"), 1))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, [
                  _createVNode(_component_inline_svg, {
                    src: "media/icons/duotune/general/gen021.svg",
                    class: "lineH"
                  })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "data-kt-subscription-table-filter": "search",
                  class: "form-control form-control-solid fs-base fw-normal ps-14 inputSearch ms-0",
                  placeholder: "Buscar vehículo",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchWord) = $event)),
                  onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems()))
                }, null, 544), [
                  [_vModelText, _ctx.searchWord]
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_Field, {
                  name: "brand",
                  autocomplete: "off",
                  class: "form-select form-select-solid select2-hidden-accessible inputSearch",
                  modelValue: _ctx.searchByBrand,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchByBrand) = $event)),
                  style: {"margin-left":"5px"}
                }, {
                  default: _withCtx(({ value, errorMessage, handleChange }) => [
                    _createVNode(_component_el_select, {
                      class: "w-100",
                      name: "brand",
                      value: value,
                      "model-value": value,
                      "onUpdate:modelValue": handleChange,
                      loading: _ctx.loading,
                      size: "large",
                      onChange: _ctx.searchCatsBrand
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          value: "Marca",
                          selected: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Marca")
                          ]),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brandsCat, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "onChange"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_Field, {
                  name: "status",
                  autocomplete: "off",
                  class: "form-select form-select-solid select2-hidden-accessible inputSearch",
                  modelValue: _ctx.searchByStatus,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchByStatus) = $event)),
                  style: {"margin-left":"5px"}
                }, {
                  default: _withCtx(({ value, errorMessage, handleChange }) => [
                    _createVNode(_component_el_select, {
                      class: "w-100",
                      name: "status",
                      value: value,
                      "model-value": value,
                      "onUpdate:modelValue": handleChange,
                      loading: _ctx.loading,
                      size: "large",
                      onChange: _ctx.searchCatsStatus
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          value: "Estatus",
                          selected: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Estatus")
                          ]),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusCat, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: item.status,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "onChange"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              (_ctx.tipoRol == 'Corporativo' && _ctx.path == '/vehicles')
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createVNode(_component_Field, {
                      name: "agency",
                      autocomplete: "off",
                      class: "form-select form-select-solid select2-hidden-accessible inputSearch",
                      modelValue: _ctx.searchByAgency,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchByAgency) = $event)),
                      style: {"margin-left":"5px"}
                    }, {
                      default: _withCtx(({ value, errorMessage, handleChange }) => [
                        _createVNode(_component_el_select, {
                          class: "w-100",
                          name: "agency",
                          value: value,
                          "model-value": value,
                          "onUpdate:modelValue": handleChange,
                          loading: _ctx.loading,
                          size: "large",
                          onChange: _ctx.searchCatsAgency
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              value: "Agencia",
                              selected: true
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Agencia")
                              ]),
                              _: 1
                            }),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agenciesCat, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: index,
                                label: item.nombre,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "onChange"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("button", {
              type: "button",
              class: "btn me-3 btnDescargar btn-secondary btn-responsive btn-download",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.downloadReport && _ctx.downloadReport(...args)))
            }, [
              _createElementVNode("span", _hoisted_19, [
                _createVNode(_component_inline_svg, { src: "media/icons/iconsax/directbox-receive.svg" })
              ]),
              _hoisted_20
            ], 512), [
              [_vShow, false]
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn me-3 btn-primary fs-base btn-responsive btn-create",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.synchronize && _ctx.synchronize(...args)))
            }, [
              _createElementVNode("span", _hoisted_21, [
                _createVNode(_component_inline_svg, { src: "media/icons/iconsax/directbox-receive.svg" })
              ]),
              _hoisted_22
            ]),
            (_ctx.can('Crear vehículo'))
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  type: "button",
                  class: "btn me-3 btn-primary fs-base btn-responsive btn-create",
                  to: { name: 'new-edit-vehicles' }
                }, {
                  default: _withCtx(() => [
                    _hoisted_23
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (_ctx.hasAgencies)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_27, [
        _createVNode(_component_Datatable, {
          "table-data": _ctx.tableData1,
          loading: _ctx.loading,
          "table-header": _ctx.headerConfig,
          "enable-items-per-page-dropdown": false,
          rowsPerPage: parseInt(_ctx.showing),
          showRow: _ctx.nextToShow
        }, _createSlots({
          "cell-vin": _withCtx(({ row: customer }) => [
            _createElementVNode("div", null, [
              _createVNode(_component_router_link, {
                to: '/vehicles/' + customer.id,
                class: "text-white text-hover-primary mb-1"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(customer.vin), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ]),
          "cell-anio": _withCtx(({ row: customer }) => [
            _createElementVNode("div", null, _toDisplayString(customer.anio), 1)
          ]),
          "cell-marca": _withCtx(({ row: customer }) => [
            _createElementVNode("div", null, _toDisplayString(customer.marca), 1)
          ]),
          "cell-modelo": _withCtx(({ row: customer }) => [
            (_ctx.tipoRol == 'Corporativo')
              ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(customer.modelo), 1))
              : _createCommentVNode("", true),
            (_ctx.tipoRol == 'Múltiples agencias')
              ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(customer.modelo), 1))
              : _createCommentVNode("", true),
            (_ctx.tipoRol == 'Múltiples agencias' && _ctx.showStatics)
              ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(customer.version), 1))
              : _createCommentVNode("", true)
          ]),
          "cell-estatus": _withCtx(({ row: customer }) => [
            _withDirectives(_createElementVNode("img", _hoisted_32, null, 512), [
              [_vShow, customer.estatus === 'Apartado']
            ]),
            _withDirectives(_createElementVNode("img", _hoisted_33, null, 512), [
              [_vShow, customer.estatus === 'Revisión']
            ]),
            _withDirectives(_createElementVNode("img", _hoisted_34, null, 512), [
              [_vShow, 
                customer.estatus === 'Próximamente' ||
                customer.estatus === 'Eliminado'
              ]
            ]),
            _withDirectives(_createElementVNode("img", _hoisted_35, null, 512), [
              [_vShow, 
                customer.estatus === 'Disponible' ||
                customer.estatus === 'Vendido'
              ]
            ]),
            _createTextVNode(_toDisplayString(customer.estatus), 1)
          ]),
          "cell-actions": _withCtx(({ row: customer }) => [
            _createElementVNode("div", null, [
              (
                  customer.estatus !== 'Próximamente' &&
                  customer.estatus !== 'Vendido' &&
                  customer.estatus !== 'Eliminado' &&
                  _ctx.can('Editar vehículo') &&
                  _ctx.showStatics
                )
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    class: "btn btn-sm btn-icon btn-active-icon-primary",
                    to: '/nevehicle/' + customer.id
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_inline_svg, { src: "media/icons/iconsax/edit-2.svg" })
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : _createCommentVNode("", true),
              (
                  customer.estatus !== 'Próximamente' &&
                  customer.estatus !== 'Vendido' &&
                  customer.estatus !== 'Eliminado' &&
                  _ctx.can('Eliminar vehículo') &&
                  _ctx.showStatics
                )
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: "btn btn-sm btn-icon btn-active-icon-primary",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#deleteVehicleModal",
                    onClick: ($event: any) => (_ctx.deleteVehicle(customer.id))
                  }, [
                    _createVNode(_component_inline_svg, { src: "media/icons/iconsax/trash.svg" })
                  ], 8, _hoisted_36))
                : _createCommentVNode("", true),
              (customer.estatus === 'Próximamente' && _ctx.showStatics)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 2,
                    to: "#",
                    class: "text-blue-800 text-hover-primary mb-1",
                    style: {"text-decoration":"underline"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Publicar ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_ctx.showStatics && _ctx.nextToShow != customer.id)
                ? (_openBlock(), _createBlock(_component_inline_svg, {
                    key: 3,
                    src: "media/icons/iconsax/arrow-down.svg",
                    class: "arrowDown",
                    onClick: ($event: any) => (_ctx.showNextRow(customer.id))
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (!_ctx.showStatics && _ctx.nextToShow == customer.id)
                ? (_openBlock(), _createBlock(_component_inline_svg, {
                    key: 4,
                    src: "media/icons/iconsax/arrow-up.svg",
                    class: "arrowDown",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.hideRow()))
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 2
        }, [
          (_ctx.tipoRol == 'Corporativo')
            ? {
                name: "cell-version",
                fn: _withCtx(({ row: customer }) => [
                  _createElementVNode("span", _hoisted_31, _toDisplayString(customer.version), 1)
                ]),
                key: "0"
              }
            : undefined,
          (_ctx.tipoRol == 'Corporativo' && _ctx.mostrarAgencia)
            ? {
                name: "cell-agencia",
                fn: _withCtx(({ row: customer }) => [
                  _createTextVNode(_toDisplayString(customer.agencia), 1)
                ]),
                key: "1"
              }
            : undefined
        ]), 1032, ["table-data", "loading", "table-header", "rowsPerPage", "showRow"]),
        (_ctx.noResults)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39))
          : _createCommentVNode("", true),
        (_ctx.total > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _withDirectives(_createElementVNode("span", _hoisted_42, "Elementos por página:", 512), [
                  [_vShow, _ctx.links.length > 0]
                ]),
                _withDirectives(_createVNode(_component_Field, {
                  name: "pages",
                  autocomplete: "off",
                  class: "form-select form-select-solid select2-hidden-accessible pageNumber",
                  modelValue: _ctx.showing,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showing) = $event))
                }, {
                  default: _withCtx(({ value, errorMessage, handleChange }) => [
                    _createVNode(_component_el_select, {
                      name: "pages",
                      value: value,
                      "model-value": value,
                      "onUpdate:modelValue": handleChange,
                      loading: _ctx.loading,
                      class: _normalizeClass([_ctx.pageNumber, "w-75px"]),
                      onChange: _ctx.showingSet
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          class: _normalizeClass(_ctx.fs - _ctx.sm),
                          value: 10,
                          selected: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("10")
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_el_option, {
                          class: _normalizeClass(_ctx.fs - _ctx.sm),
                          value: 25,
                          selected: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("25")
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_el_option, {
                          class: _normalizeClass(_ctx.fs - _ctx.sm),
                          value: 50,
                          selected: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("50")
                          ]),
                          _: 1
                        }, 8, ["class"]),
                        _createVNode(_component_el_option, {
                          class: _normalizeClass(_ctx.fs - _ctx.sm),
                          value: 100,
                          selected: true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("100")
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ]),
                      _: 2
                    }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "class", "onChange"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]), [
                  [_vShow, _ctx.links.length > 0]
                ]),
                _withDirectives(_createElementVNode("span", { class: "w-25" }, " " + _toDisplayString(_ctx.from) + " - " + _toDisplayString(_ctx.to) + " de " + _toDisplayString(_ctx.total), 513), [
                  [_vShow, _ctx.links.length > 0]
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _withDirectives(_createElementVNode("div", _hoisted_44, [
                  _createElementVNode("ul", _hoisted_45, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (lin, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: index,
                        class: _normalizeClass([
                    lin ? 'page-item' : '',
                    lin.active ? 'active' : '',
                    lin.url == null ? 'disabled' : '',
                  ]),
                        onClick: ($event: any) => (_ctx.getPagination(lin))
                      }, [
                        (lin.url != null)
                          ? (_openBlock(), _createElementBlock("a", _hoisted_47, _toDisplayString(lin.label.includes("Anterior")
                        ? "<"
                        : lin.label.includes("Siguiente")
                        ? ">"
                        : lin.label), 1))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_46))
                    }), 128))
                  ])
                ], 512), [
                  [_vShow, _ctx.links.length > 0]
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_ModalDeleteVehicle, {
      onFinishDelete: _cache[9] || (_cache[9] = ($event: any) => (_ctx.finishAction($event))),
      vehicleId: _ctx.vehicleId,
      marca: _ctx.marca,
      version: _ctx.version,
      modelo: _ctx.modelo,
      anio: _ctx.anio
    }, null, 8, ["vehicleId", "marca", "version", "modelo", "anio"])
  ]))
}